import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationConstants } from '@constants/app.constants';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  apiUrl = environment.taskApiUrl;
  apiMasterUploadUrl = `${environment.masterServiceApiUrl}/TaskMasterData`;
  apiQuestionBankUploadUrl = `${environment.masterServiceApiUrl}/Questionbank`;
  constructor(private readonly http: HttpClient) { }

  uploadTasks(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.http.post(
    `${this.apiUrl}/TaskUpload/Upload`,
    formData,
    {  responseType: 'text' }
  );
    // return this.http.post(`${this.apiUrl}/TaskUpload/Upload`, formData, { responseType: 'text' });
  }

  getUploadList(): Observable<any> {
    return this.http.get(`${this.apiUrl}/TaskUpload/Upload`);
  }

  getAllUploads(): Observable<any> {
    return this.http.get(`${this.apiUrl}/TaskUpload/GetAllUploads`);
  }

  downloadTaskFile(fileUploadId: string): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/octet-stream');
    return this.http.get(`${this.apiUrl}/TaskUpload/Download?FileUploadID=${fileUploadId}`, { headers, responseType: 'blob' });
  }

  downloadSampleFile(): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/octet-stream');
    // return this.http.get(`${this.apiUrl}/TaskUpload/DownloadSample`, { headers, responseType: 'blob' });
    return this.http.get(`${this.apiUrl}/Download/Template/Flat`, { headers, responseType: 'blob' });
  }

  downloadTaskDataFile(): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/octet-stream');
    return this.http.get(`${this.apiUrl}/Download/TaskData/Flat`, { headers, responseType: 'blob' });
  }

  uploadTaskMasterData(
    file: File,
    isFullReplacement: boolean = true,module:string = ApplicationConstants.PMPRO
  ): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    const url = 
    module === ApplicationConstants.PMPRO 
    ? this.apiMasterUploadUrl 
    : this.apiQuestionBankUploadUrl;
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.http.post(`${url}/Upload?IsFullReplacement=${isFullReplacement}`, formData, {
      headers,
    });
  }

  downloadMasterDataTemplate(): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/octet-stream');
    return this.http.get(`${this.apiQuestionBankUploadUrl}/Template`, { headers, responseType: 'blob' });
  }
}